import { useMutation } from "react-query";

import axios from "../../../../utils/authAxios";

import type {
  BLPSortDirection,
  BLPSortField,
  BLPTableRowDto,
} from "./getBLPTable";

const apiBaseUrl =
    process.env.REACT_APP_API_BASEURL +
    "/BusinessLicensePermits";

export interface FilteredBLPFilters {
  busLicensePermitTypeId: number[];
  issuerId: number[];
  licenseOrPermitNumberId: string[];
  storeNumberId: string[];
  licenseStatusId: number | null;
  isOldLicense: boolean | null;
}

export interface FilteredBLPRequest
    extends FilteredBLPFilters {
  pageNumber: number;
  pageSize: number;
  search?: string | null;
  sortField?: BLPSortField;
  sortDirection?: BLPSortDirection;
}

export interface FilteredBLPResponse {
  items: BLPTableRowDto[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}

interface FilteredBLPApiResponse {
  items?: BLPTableRowDto[];
  Items?: BLPTableRowDto[];

  totalCount?: number;
  TotalCount?: number;

  pageNumber?: number;
  PageNumber?: number;

  pageSize?: number;
  PageSize?: number;
}

const createFilteredBLPParams = (
  request: FilteredBLPRequest
): URLSearchParams => {
  const params = new URLSearchParams();

    request.busLicensePermitTypeId.forEach(
        (value) => {
    if (Number.isFinite(value)) {
        params.append(
            "busLicensePermitTypeId",
            String(value)
        );
    }
  }
  );

  request.issuerId.forEach((value) => {
    if (Number.isFinite(value)) {
        params.append(
            "issuerId",
            String(value)
        );
    }
  });

    request.licenseOrPermitNumberId.forEach(
        (value) => {
            const normalizedValue =
                String(value).trim();

    if (normalizedValue !== "") {
        params.append(
            "licenseOrPermitNumberId",
            normalizedValue
        );
    }
        }
    );

    request.storeNumberId.forEach((value) => {
        params.append("storeNumberId", value);
    });

  if (request.licenseStatusId !== null) {
      params.set(
          "licenseStatusId",
          String(request.licenseStatusId)
      );
  }

  if (request.isOldLicense !== null) {
      params.set(
          "isOldLicense",
          String(request.isOldLicense)
      );
  }

  params.set(
    "pageNumber",
      String(
          request.pageNumber > 0
          ? request.pageNumber
              : 1
      )
  );

    params.set(
        "pageSize",
        String(
            request.pageSize > 0
            ? request.pageSize
                : 10
        )
    );

    const search =
        request.search?.trim() ?? "";

  if (search !== "") {
    params.set("search", search);
  }

    params.set(
        "sortField",
        request.sortField ?? "recordId"
    );

    params.set(
        "sortDirection",
        request.sortDirection ?? "desc"
    );

  return params;
};

export const getFilteredBLP = async (
  request: FilteredBLPRequest
): Promise<FilteredBLPResponse> => {
    const response =
        await axios.get<FilteredBLPApiResponse>(
    `${apiBaseUrl}/FilteredBusLicensePermits`,
    {
        params:
            createFilteredBLPParams(
                    request
                ),
    }
  );

  const result = response.data;

    return {
        items:
            result.items ??
            result.Items ??
            [],

        totalCount:
            result.totalCount ??
            result.TotalCount ??
            0,

        pageNumber:
            result.pageNumber ??
            result.PageNumber ??
            request.pageNumber,

        pageSize:
            result.pageSize ??
            result.PageSize ??
            request.pageSize,
    };
};

export const useFilteredBLP = () => {
    return useMutation<
        FilteredBLPResponse,
        unknown,
        FilteredBLPRequest
    >(getFilteredBLP);
};